
import { defineComponent } from "vue";

export default defineComponent({
    name: "CopyrightHover",
    props: {
        text: {
            type: String,
            required: true,
        },
    },
});
